<script setup lang="ts">
import Cc3AuthShell from '@/app/Cc3AuthShell.vue'
</script>

<template>
  <Cc3AuthShell />
</template>
